import { LoadingOverlay } from "@mantine/core"
import {
  DefaultModal,
  DefaultModalProps,
} from "../../../../-components/default-modal"
import { ChatType } from "../../../../@client/Theasoft_DataTypes_Enums"
import { CreateChat } from "../../../../orval/gen/model"
import { useForm } from "@mantine/form"
import { useNavigate } from "@tanstack/react-router"
import { showErrorNotification } from "../../../../utils/form-submission-notifications"
import { CreateUpdateChatForm } from "../CreateUpdateChatForm"
import { useGetAuthenticatedUser } from "../../../app/-components/use-authenticated-user"
import { useTranslation } from "react-i18next"
import { useCreateChat } from "@/orval/gen"

interface Props extends DefaultModalProps {
  chatType: ChatType
}

export function CreateChatModal({ chatType, ...props }: Props) {
  const currentUserId = useGetAuthenticatedUser().data.userId
  const isFeedType = ["Feed", "BroadcastFeed"].includes(chatType)
  const form = useForm<CreateChat>({
    mode: "uncontrolled",
    initialValues: {
      chatType,
      chatMembers: [{ userId: currentUserId, isAdmin: true }],
      name: "",
      isReadOnly: false,
    },
  })
  const navigate = useNavigate()
  const { mutateAsync: createChateAsync, isPending } = useCreateChat({
    mutation: {
      onSuccess: (chat) => {
        if (isFeedType) {
          navigate({
            to: "/app/com/feeds/$feedId",
            params: { feedId: chat.chatId.toString() },
          })
        } else {
          navigate({
            to: "/app/com/chat/$chatId",
            params: { chatId: chat.chatId.toString() },
          })
        }
        props.onClose()
      },
      onError: showErrorNotification,
    },
  })
  const handleSubmit = async (data: CreateChat) => {
    await createChateAsync({ data })
  }
  const { t } = useTranslation("app_server")

  return (
    <DefaultModal title={t(`ChatType_${form.getValues().chatType}`)} {...props}>
      <LoadingOverlay visible={isPending} />
      <CreateUpdateChatForm
        form={form}
        onSubmit={handleSubmit}
        onCancel={props.onClose}
      />
    </DefaultModal>
  )
}
